// extracted by mini-css-extract-plugin
export default {"ProfileData":"ProfileData_ProfileData__TemXq","ProfileDataBox":"ProfileData_ProfileDataBox__NFjmk","FetchProfile":"ProfileData_FetchProfile__x3EQx"};